function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from 'prop-types';
import { DEFAULT_BREAKPOINTS, DEFAULT_MIN_BREAKPOINT } from "./ThemeProvider";
export function responsivePropType(propType) {
  return PropTypes.oneOfType([propType, PropTypes.shape({
    xs: propType,
    sm: propType,
    md: propType,
    lg: propType,
    xl: propType,
    xxl: propType
  })]);
}
export default function createUtilityClassName(utilityValues) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BREAKPOINTS;
  var minBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MIN_BREAKPOINT;
  var classes = [];
  Object.entries(utilityValues).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        utilName = _ref2[0],
        utilValue = _ref2[1];

    if (utilValue != null) {
      if (_typeof(utilValue) === 'object') {
        breakpoints.forEach(function (brkPoint) {
          var bpValue = utilValue[brkPoint];

          if (bpValue != null) {
            var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
            classes.push("".concat(utilName).concat(infix, "-").concat(bpValue));
          }
        });
      } else {
        classes.push("".concat(utilName, "-").concat(utilValue));
      }
    }
  });
  return classes;
}